import cssUtil from 'gw-portals-util-js/CssUtil';

import listTemplate from 'text!./List.html';
import listStyles from './List-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(listTemplate, listStyles),
        scope: {
            schedule: '&'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/readonly/Mobile/Mobile.js
// module id = 293
// module chunks = 0